module.exports = __webpack_public_path__ + "static/img/1224cb5b5d274d67825f5f861b764e5a_mergeImage.7a3a994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1224cb5b5d274d67825f5f861b764e5a_mergeImage.png
// module id = l5jb
// module chunks = 1